export class PersonPicture{
    public personGuid: string;
    public personPicture: string;
    public format: string;
    public assignorGuid: string;
    public managerGuid: string;
}

export class PersonDocument{
    public personGuid: string;
    public principalAttachment: string;
    public auxiliarAttachment: string;
    public format: string;
    public assignorGuid: string;
    public managerGuid: string;
}

export class PersonAddress{
    public personGuid: string;
    public personAddress: AddressKyc;
    public assignorGuid: string;
    public managerGuid: string;
}

export class PersonFiles{
    public personGuid: string;
    public personPicture: string;
    public principalAttachment: string;
    public auxiliarAttachment: string;
    public personPictureFormat: string;
    public principalAttachmentFormat: string;
    public auxiliarAttachmentFormat: string;
    public personAddress?: AddressKyc;
    public assignorGuid: string;
    public managerGuid: string;
}

export class PersonInformation
{
    constructor(
        public personGuid: string,
        public email: string,
        public phone?: number,
        public openingDate?: Date
    ){ }

}

export class AddressKyc {
    zipCode: string;
    addressName: string;
    number: string;
    complement: string;
    neighborhood: string;
    city: string;
    uf: string
}

export class KycValidations {
    kycTypeId: number;
    kycValidated: boolean;
}

export class ValidateAssignorResponse {
    personEmail: boolean;
    personPhone: boolean;
    legalPersonOpeningDate: boolean;
}

export class StatusValidation {
    personValidationId: number;
    validationTypeId: number;
    statusId: number;
}
